class FeedRemapCtrl {

    constructor($scope, $feedService, $routeParams, Notification, ApiService, CONTENT_TYPE, EVENTS) {

        this.$scope = $scope;
        this.EVENTS = EVENTS;
        this.$feedService = $feedService;
        this.feedId = $routeParams.feedId;
        this.Notification = Notification;
        this.isSaving = false;
        this.isDeleting = false;
        this.isRegenerating = false;
        this.mappings = [];

        this.standardFields = [
            { name: "sku", label: "Unique Id"},
            { name: "title", label: "Title"},
            { name: "category", label: "Category"},
            { name: "price", label: "Price"},
            { name: "imageUrl", label: "Image URL"},
            { name: "clickUrl", label: "Click URL"},
            { name: "weight", label: "Weight"},
            { name: "location", label: "Location"}
        ];

        this.$scope.save = this.save.bind(this);

        this.getFeedMappings();
    }

    save() {
        this.isSaving = true;
        this.$feedService.saveFeedMappings(this.feedId, this.mappings)
            .then(resp => {
                this.mappings = resp.data;
                this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Save successful.'});
                this.isSaving = false;
            }, err => {
                this.error = true;
                this.isSaving = false;
                console.error(err);
            });
    }

    delete() {
        this.isDeleting = true;
        this.$feedService.deleteFeedMappings(this.feedId)
            .then(resp => {
                //Could probably just clear the mappings object, this just confirms they 
                //were actually deleted though
                this.getFeedMappings();
                this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Deletion successful.'});
                this.isDeleting = false;
            }, err => {
                this.error = true;
                this.isDeleting = false;
                console.error(err);
            });
    }

    regenerate() {
        this.isRegenerating = true;
        this.$feedService.regenerateFeedMappings(this.feedId)
            .then(resp => {
                this.getFeedMappings();
                this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Regeneration successful.'});
                this.isRegenerating = false;
            }, err => {
                this.error = true;
                console.error(err);
                this.isRegenerating = false;
            });
    }

    getFeedMappings() {
        this.$feedService.getFeedMappings(this.feedId)
            .then(resp => this.mappings = resp.data, err => console.error(err));
    }

    addMapping() {
        let mapping = {srcName: null, dstName: null, dataType: null, filterable: false, skip: false, rehostImages: false, feedId: this.feedId};
        this.mappings.push(mapping);
    }

    deleteMapping(idx) {
        this.mappings.splice(idx, 1);
    }
}

angular.module('cpm')
    .controller('FeedRemapCtrl', ['$scope', '$feedService', '$routeParams', 'Notification', 'ApiService','CONTENT_TYPE', 'EVENTS', FeedRemapCtrl]);
